/**
 * Constants for VehicleInformationStep component
 */

export const DATE_FORMAT = 'YYYY-MM-DD';
export const RC_DOCUMENT_LABEL = 'RC Document';
export const INSURANCE_DOCUMENT_LABEL = 'Insurance Document';
export const PUC_DOCUMENT_LABEL = 'PUC Document';
export const CONSENT_LETTER_LABEL = 'Consent Letter';
export const VEHICLE_TYPE_LABEL = 'Vehicle Type';
export const VEHICLE_NUMBER_LABEL = 'Vehicle Number';
export const VALID_TILL_LABEL = 'Valid Till';
export const OWNERSHIP_TYPE_LABEL = 'Ownership Type';
export const FILE_UPLOAD_INFO_MESSAGE = 'Please use the main form to upload files';

export const OWNERSHIP_TYPE_OPTIONS = [
	{ value: 'Own', label: 'Own' },
	{ value: 'Aggregator', label: 'Aggregator' },
];

export const MAX_FILE_SIZE = 5 * 1024 * 1024; // 5MB
export const UPLOADING_TEXT = 'Uploading...';
export const BROWSE_FILE_TEXT = 'Browse File';
